module.exports = __webpack_public_path__ + "img/zizhi8.edc66da9.png";